export default "__VITE_PUBLIC_ASSET__eb172353__"